
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-org-picker-config",
})
export default class OrgPickerConfig extends ComponentConfigMixins {}
